// API URL for backend calls (used for downloads, etc.)
export const API_URL = window.location.toString().startsWith('http://localhost')
  ? 'http://localhost:5001'
  : ''

// Public URL for share links (from env variable)
export const HOST_URL = import.meta.env.HOST_URL || window.location.origin

export const numberFormat = new Intl.NumberFormat('en-gb', { minimumFractionDigits: 2 })